import React, { useState } from 'react';
import { faqs } from '../mock';
import { ChevronDown, MessageCircle } from 'lucide-react';

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-20">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-slate-400">Got questions? We&apos;ve got answers</p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={i}
                className={`rounded-xl border transition-colors ${
                  open ? 'border-emerald-500/40 bg-[#0f1725]' : 'border-white/5 bg-[#0f1725] hover:border-white/10'
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-white font-semibold">{f.q}</span>
                  <ChevronDown
                    className={`text-emerald-400 flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
                    size={20}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-slate-400 text-sm leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <p className="text-slate-400 text-sm">Still have questions?</p>
          <a
            href="#"
            className="mt-3 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 hover:bg-emerald-500/20 transition-colors font-semibold text-sm"
          >
            <MessageCircle size={16} /> Chat with Us on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
